<template>
 <div class="page">
      <box>
        <el-form label-position="right" label-width="80px" class="EL-Form">
            <el-col :lg="5" :xl="5">
                <el-form-item label="通道编号" class="EL-Form-Item">
                    <el-select v-model="mainSearch.query.whCode" placeholder="请选择" filterable clearable="clearable">
                        <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="物料编号" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5" >
                <el-form-item label="物料描述" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.matName" placeholder="请输入"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="库位" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.lcCode" placeholder="请输入"></el-input>
                    <!-- <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                        <el-option v-for="(item, index) in storageObj.lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                        </el-option>
                    </el-select> -->
                </el-form-item>
            </el-col>
            <el-col :lg="4" :xl="4">
                <el-form-item class="btn-edit-delete EL-Form-Item">
                    <el-button class="btn-t-edit" @click="inquireDataClick('mainSearch')">
                        查询
                    </el-button>
                    <el-button class="btn-t-delete" @click="resetClick('mainSearch')">重置</el-button>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="批次号" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.batchNo" placeholder="请输入"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="包装编号" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="订单编号" class="EL-Form-Item">
                    <el-input v-model="mainSearch.query.orderCode" placeholder="请输入"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="开始日期" class="EL-Form-Item">
                    <el-date-picker v-model="mainSearch.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="结束日期" class="EL-Form-Item">
                    <el-date-picker v-model="mainSearch.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-form>
      </box>
      <box fill>
        <plabel text="库存列表">
            <el-button class="btn-t-edit" v-authority="'BACK_MENU2_M4_B2'" @click="ControlDialog('ch')">通道转移</el-button>
            <el-button class="btn-t-edit" v-authority="'BACK_MENU2_M4_B1'" @click="ControlDialog()">新增</el-button>
        </plabel>
        <h-table :summary-method="getSummaries" show-summary :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainSearch.data" pagination :nowPage.sync="mainSearch.pageNum" :pageSize.sync="mainSearch.pageSize" :total.sync="mainSearch.total" @selectionChange="selectRepertory">
          <el-table-column type="selection" align="center"> </el-table-column>
          <el-table-column label="通道编号" prop="whCode" align="center">
          </el-table-column>
          <el-table-column label="物料编号" prop="matCode" align="center">
          </el-table-column>
          <el-table-column label="物料描述" prop="matName" align="center">
          </el-table-column>
          <el-table-column label="数量" prop="matQuan" align="center">
          </el-table-column>
          <el-table-column label="已分配数量" prop="matDistrQuan" align="center">
          </el-table-column>
          <el-table-column label="可用数量" prop="matAvaliableQuan" align="center">
            <template slot-scope="scope">
              {{scope.row.matQuan - scope.row.matDistrQuan}}
            </template>
          </el-table-column>
          <el-table-column label="批次号" prop="batchNo" align="center">
          </el-table-column>
          <el-table-column label="库位" prop="lcCode" align="center">
          </el-table-column>     
          <el-table-column label="包装箱号" prop="boxBarcode" align="center">
          </el-table-column>
          <el-table-column label="订单编号" prop="orderCode" align="center">
          </el-table-column>
          <el-table-column label="规值" prop="matSpecs" align="center">
          </el-table-column>
          <el-table-column label="是否半成品" align="center" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.halfProductFlag == false ">否</span>
              <span v-if="scope.row.halfProductFlag == true ">是</span>
            </template>
          </el-table-column>
          <el-table-column label="是否组件" align="center" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.assemblyFlag == false || scope.row.assemblyFlag==''">否</span>
              <span v-if="scope.row.assemblyFlag == true ">是</span>
            </template>
          </el-table-column>
          <el-table-column label="入库时间" prop="matCreateTime" align="center" :formatter="dateFormat" width="140px">
          </el-table-column>
        </h-table>
      </box>
        <!-- 库位调整 -->
      <el-dialog title="库位调整" :visible.sync="whInventorySearch.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
        <el-form label-position="right" label-width="70px" class="EL-Form">
          <!-- <el-row>
            <el-col :lg="5" :xl="5">
              <el-form-item label="仓库" class="EL-Form-Item">
                <el-select v-model="whInventorySearch.query.lcCodeType" placeholder="请选择" clearable="clearable" @change="lcCodeTypeChange">
                  <el-option v-for="(item, index) in storageObj.warehouse" :key="index" :label="item.lmName" :value="item.lmId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="库区" class="EL-Form-Item">
                    <el-cascader v-model="whInventorySearch.query.storeroomArea" :props="optionProps" :options="inventoryLocationList" collapse-tags clearable>
                    </el-cascader>
                </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                  <el-form-item label="库位" class="EL-Form-Item">
                      <el-select v-model="whInventorySearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                          <el-option v-for="(item, index) in storageObj.lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                          </el-option>
                      </el-select>
                  </el-form-item>
            </el-col>
            <el-col :lg="5" :xl="5">
                <el-form-item label="物料编号" class="EL-Form-Item">
                    <el-select v-model="whInventorySearch.query.matCode" filterable :clearable="true" remote :remote-method="remoteMethod"  @change="remoteMethod">
                        <el-option v-for="item in storageObj.materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :lg="3" :xl="3" style="float:right">
                <el-form-item class="btn-edit-delete EL-Form-Item">
                    <el-button  class="btn-t-edit" @click="getStockList()">  
                        查询
                    </el-button>
                    <el-button class="btn-t-delete" @click="resetClick('whInventorySearch')">重置</el-button>
                </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="5" :xl="5">
              <el-form-item label="托盘号" class="EL-Form-Item">
                <el-input v-model="whInventorySearch.query.palletCode" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider> -->
          <el-row>
            <el-col :lg="5" :xl="5">
              <el-form-item label="移入通道" class="EL-Form-Item">
                <el-select v-model="shiftOutSeat.traferWhCode" placeholder="请选择"  filterable>
                  <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                </el-select>
              </el-form-item>
             </el-col>
             <el-col :lg="5" :xl="5">
                <el-form-item v-if="!isch" label="移入库位" class="EL-Form-Item">
                    <el-select v-model="shiftOutSeat.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode" @change="changeTranLcCode()">
                      <el-option v-for="(item) in storageObj.lcCodeList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">
                      </el-option>
                    </el-select>
                </el-form-item>
             </el-col>
             <el-col :lg="5" :xl="5">
                <el-form-item label="备注" class="EL-Form-Item">
                  <el-input el-input v-model="shiftOutSeat.remark" placeholder="请输入"></el-input>
                </el-form-item>
             </el-col>
                </el-row>
            </el-form>
            <!-- <h-table :headerCellStyle="whInventorySearch.headerCellStyle" :style="$popups.harvestRecordStyle(0.58)" :data="whInventorySearch.data"   @pageChange="getStockList()"  pagination :nowPage.sync="whInventorySearch.pageNum" :pageSize.sync="whInventorySearch.pageSize" :total.sync="whInventorySearch.total" @selectionChange="selectAll"> -->
            <h-table :headerCellStyle="whInventorySearch.headerCellStyle" :style="$popups.harvestRecordStyle(0.64)" :data="whInventorySearch.data" :key="rowTableKey" @selectionChange="selectAll">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column  label="移库数量" v-if="!isch" prop="matTranQuan" align="center" width="150">
                  <template slot-scope="scope" >
					<el-input-number v-model="scope.row.matAvaliableQuan" :min="1" :max="scope.row.matQuan" style="width: 100%;line-height: 26px !important" size="mini"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="库位" prop="lcCode" align="center">
                </el-table-column>
                <el-table-column label="包装箱号" prop="boxBarcode" align="center">
                </el-table-column>
				<el-table-column label="移入库位" v-if="!isch" prop="traferCode" align="center" width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.traferCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode" @change="handleChange()">
                      <el-option v-for="(item) in storageObj.lcCodeList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">
                      </el-option>
                    </el-select>
                  </template>
				</el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="托盘号" prop="palletCode" align="center">
                </el-table-column>
                <el-table-column label="入库时间" prop="matCreateTime" align="center" width="140px">
                </el-table-column>
                <el-table-column label="状态" prop="wiStatus" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
                    </template>
                </el-table-column>
            </h-table>
        <div slot="footer" class="dialog-footer footer-bottom">
            <el-button size="mini" type="info" @click="closeDialogClick('whInventorySearch')">取 消</el-button>
            <el-button size="mini" class="btn-t-edit" @click="insertLocationAdjustment()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "OtherRecordOut",
  data() {
    return {
      /* 首页显示的数据 */
      mainSearch: {
        query: {
          fcCode: localStorage.getItem("fcCode") || "",
          lcCode: "",
          whCode: "",
          matCode: "",
          matName: "",
          batchNo: "",
          boxBarcode: "",
          orderCode: "",
          date: [],
        },
        pageNum: 1,
        pageSize: 50,
        total: 0,
        data: [],
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        }
      },

      person: localStorage.getItem('user'),
      personNumber: localStorage.getItem("empNumber"),
      isch:false,


      /* 新增货位调整 */
      whInventorySearch: {
        query: {
          storeroomArea: [],
          fcCode: "", // 工厂编号
          lcCode: "", //库位号
          matCode: "", //物料编号
          matCodeList: "", //多个物料编号
          lcCodeType: "",
          lcTypeSub: "",
          palletCode:"",  //托盘号
        },
        pageNum: 1,
        pageSize: 20,
        total: 0,
        data: [],
        insertShowRecord: false,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      shiftOutSeat: {
        traferWhCode: "",
        lcCode: "",
        remark: "",
      },
      // 库位调整查询条件
      storageObj: {
        // 仓库
        warehouse: [],
        // 库区
        lcCodeList: [],
        // 物料编号
        materialList: [],
      },
	  rowLcCodeList: [],
	  rowTableKey: false,

      optionProps: {
        expandTrigger: "click",
        multiple: true,
        lazy: false,
        lazyLoad: this.getLocationMenuByWarehouse,
        value: "lmRealCode",
        label: "lmName",
        children: "sysLocationMenuPOList",
      },
      // 库区集合
      WhCodeList: [],
      // 选择的库存数据
      putInMotionData: [],
      // 需要移动库位的数据
      checkList: [],
      // 下载中
      downloadLoading: false,
      // 完成后保存日志的内容
      logRemarks: "",
      // 级联选择器动态绑定的数据
      inventoryLocationList: [],
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {
    "mainSearch.query": {
      handler() {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData();
        }, 1000);
      },
      deep: true,
    },
    "whInventorySearch.query": {
      handler() {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
        //   this.getStockList();
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    startPickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.query.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.query.date[1]);
          }
        },
      };
    },
    finishPickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.query.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.query.date[0]);
          }
        },
      };
    },
  },
  methods: {
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = '合计';
            return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) && (column.property == "matQuan" || column.property == "matDistrQuan" ||column.property == "matAvaliableQuan")) {
             sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
                return prev + curr;
            } else {
                return prev;
            }
            }, 0);
            sums[index];
        } 
        });

        return sums;
    },
    lcCodeTypeChange() {
      this.optionProps.lazy = true;
      this.optionProps.lazyLoad();
    },
    /* 根据仓库id获取所有的库位类型 */
    getLocationMenuByWarehouse(node, resolve) {
      console.log(node);
      if (this.whInventorySearch.query.lcCodeType) {
        this.$http
          .request({
            url: "/api/location/getLocationMenus",
            method: "GET",
            params: {
              lmId: this.whInventorySearch.query.lcCodeType,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              if (resolve) {
                resolve(resp.data.list);
              } else {
                this.inventoryLocationList = resp.data.list;
              }
              this.optionProps.lazy = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
      } else {
        this.$message({
          message: "请先选择仓库！",
          type: "warning",
        });
      }
    },
    /* 选择数据进行库位切换 */
    selectAll(val) {
      this.checkList = val;
    },

	//统一移入库位
	changeTranLcCode(){
		if(this.shiftOutSeat.lcCode !=''){
			this.whInventorySearch.data.forEach((item)=>{
				item['traferCode'] = this.shiftOutSeat.lcCode;
			})
			this.rowTableKey = !this.rowTableKey;
		}
	},
	handleChange(){
		this.$forceUpdate();
	    this.rowTableKey = !this.rowTableKey;
	},

    /* 库位调整 */
    insertLocationAdjustment() {
      var statusFlag = false;
      var lcCodeFlag = false;
      var lcCodeWhcodeFlag = false;
      this.checkList.forEach((item) => {
        if (item.wiStatus == "FREEZE" || item.wiStatus == "AGFREEZE") {
          statusFlag = true;
        }
        if(item.lcCode == item.traferCode){
          lcCodeFlag = true;
        }
        if(item.traferCode == "" && this.shiftOutSeat.traferWhCode == ""){
          lcCodeWhcodeFlag = true;  
        }
      });

	  if (this.checkList == 0) {
        this.$message({
          message: "请选择需要调整的数据！",
          type: "warning",
        });
        return;
      } else if (statusFlag) {
        this.$message({
          message: "不能对拣货冻结的物料进行库位调整！",
          type: "warning",
        });
        return;
      } else if (lcCodeWhcodeFlag) {
        this.$message({
          message: "请对库位进行移库或者移通道操作！",
          type: "warning",
        });
        return;
      } else if (lcCodeFlag && this.shiftOutSeat.traferWhCode == '') {
        this.$message({
          message: "移入的库位不能和原库位相同！",
          type: "warning",
        });
        return;
      } else {
        this.checkList.forEach((item) => {
		  item.matTranQuan = item.matAvaliableQuan;
          item.traferWhCode = this.shiftOutSeat.traferWhCode;
          if (this.shiftOutSeat.lcCode == "" && this.shiftOutSeat.traferWhCode != "") {
            // 如果填了通道,不填货位,默认只转移通道,库位不变
            if(item.traferCode == '' || item.traferCode=='undefined'){ //如果已选择库位为空
				item.traferCode = item.lcCode;
			}
          } else if ( this.shiftOutSeat.lcCode != "" && this.shiftOutSeat.traferWhCode == "") {
            // 如果只填了库位,不填通道,则通道不变
            item.traferWhCode = item.whCode;
          	item.traferCode = this.shiftOutSeat.lcCode.toUpperCase();
          } else {
            // 如果填了通道,不填货位,默认只转移通道,库位不变
            if(item.traferCode == '' || item.traferCode==undefined){ //如果已选择库位为空
				if(this.shiftOutSeat.lcCode != ""){  //移入库位不为空时，以上面为主
					item.traferCode = this.shiftOutSeat.lcCode.toUpperCase();
				}else{
					item.traferCode = item.lcCode;
				}
			}
			if(this.shiftOutSeat.traferWhCode == ""){
				item.traferWhCode = item.whCode;
			}
          }
        });
        this.insertLocationAdjustments = true;

        //进行库位调整
        this.$confirm("确定开始进行库位调整吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .request({
                url: "/api/stockMove/insertStockMove",
                method: "POST",
                showLoading: true,
                params: {
                //   fcCode: this.fcCode, //工厂编号
                  remark: this.shiftOutSeat.remark, //备注
                  person: this.person, //库位调整操作人
                  personNumber: this.personNumber, //库位调整操作人工号
                },
                data: this.checkList, //库位调整集合对象
              })
              .then((res) => {
                if (res.status == 100) {
                  this.$message({
                    message: "库位调整成功!",
                    type: "success",
                  });
                  this.logRemarks = "stockMove：新增库位调整成功";
                  this.whInventorySearch = {
                    query: {
                      storeroomArea: [],
                      fcCode: "", // 工厂编号
                      lcCode: "", //库位号
                      matCode: "", //物料编号
                      matCodeList: "", //多个物料编号
                      lcCodeType: "",
                      lcTypeSub: "",
                      palletCode:"",  //托盘号
                    },
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    data: [],
                    insertShowRecord: false,
                    headerCellStyle: () => {
                      return "background-color: #1f6cec";
                    },
                  };
                  this.shiftOutSeat = {
                    traferWhCode: "",
                    lcCode: "",
                    remark: "",
                  };
                  this.mainSearch.query.lcCode = "";
                  this.getSysLocationAll();
                  this.getTableData();
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                  this.logRemarks = "stockMove：新增库位调整失败";
                }
                this.insertLocationAdjustments = false;
                this.systemLog();
              });
          })
          .catch(() => {
            this.insertLocationAdjustments = false;
            this.$message({
              type: "info",
              message: "已取消库位调整！",
            });
          });
      }
    },
    // 货位调整的弹出框
    ControlDialog(type) {
      if(type == 'ch'){
        this.isch =true;
      }else{
        this.isch = false;
      }
      this.mainSearch.query.lcCode = "";
      this.getSysLocationAll();
      if (this.putInMotionData.length) {
        this.shiftOutSeat = {
          traferWhCode: "",
          lcCode: "",
          remark: "",
        };
        var isFlag = false;
				this.putInMotionData.forEach((item)=>{
					item['traferCode'] = "";
          if(item.matDistrQuan>0){
            this.$message({
              type: "info",
              message: "已经分配的库存不能移库！",
            });
            isFlag = true;
            return;
          }
				})
        if(isFlag){
          return;
        }
				// const res = this.putInMotionData.every(e => {
				// 	if (e.lcType == 'QC') {
				// 		this.$message({
				// 			message: "QC类型的库位不允许被移库！！",
				// 			type: "warning",
				// 		});
				// 		return false;
				// 	} else {
				// 		return true;
				// 	}
				// })
				// if (res == false) {
				// 	return false;
				// }
        this.whInventorySearch.data = this.putInMotionData;
      	this.whInventorySearch.insertShowRecord = true;
				this.getSysWarehouseAll();
      } else {
				this.$message({
					type: "info",
					message: "请选择库存",
				});
				return;
			}
    },
    /* 库存选择 */
    selectRepertory(selection) {
      this.putInMotionData = selection;
    },
    /* 所有弹出框关闭的点击事件 */
    closeDialogClick(type) {
      if (type == "whInventorySearch") {
        this.whInventorySearch.insertShowRecord = false;
        this.whInventorySearch.query = {
          storeroomArea: [],
          fcCode: "", // 工厂编号
          lcCode: "", //库位号
          matCode: "", //物料编号
          matCodeList: "", //多个物料编号
          lcCodeType: "",
          lcTypeSub: "",
          palletCode:"",  //托盘号
        };
        this.mainSearch.query.lcCode = "";
        this.getSysLocationAll();
        this.whInventorySearch.data = [];
      }
    },
    /* 所有查询的点击事件 */
    inquireDataClick(type) {
      if (type == "mainSearch") {
        this.mainSearch.pageNum = 1;
        this.getTableData();
      }
    },
    /* 所有重置的点击事件 */
    resetClick(type) {
      if (type == "mainSearch") {
        this.mainSearch.query = {
          fcCode: localStorage.getItem("fcCode") || "",
          lcCode: "",
          whCode: "",
          matCode: "",
          matName: "",
          batchNo: "",
          boxBarcode: "",
          orderCode: "",
          date: [],
        };
        this.mainSearch.pageNum = 1;
      } else if (type == "whInventorySearch") {
        this.whInventorySearch.query = {
          fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
          storeroomArea: [],
          lcCode: "", // 库位号
          matCode: "", // 物料编号
          matCodeList: "", // 多个物料编号
          lcCodeType: "",
          lcTypeSub: "",
          palletCode:"",  //托盘号
        };
        this.whInventorySearch.pageNum = 1;
        this.whInventorySearch.data = [];
      }
    },
    /* 查询库存记录 */
    getStockList() {
      // this.whInventorySearch.query.storeroomArea  lcType\
      var map = this.whInventorySearch.query.storeroomArea.map((ele) => {
        return ele[1];
      });
      this.$http
        .request({
          url: "/api/inventory/getStockList",
          method: "GET",
          params: {
            pageNum: this.whInventorySearch.pageNum, //	页号
            pageSize: this.whInventorySearch.pageSize, //	页大小
            fcCode: this.whInventorySearch.query.fcCode || null, //	工厂编号
            matCode: this.whInventorySearch.query.matCode || null, // 物料编号
            lcCode: this.whInventorySearch.query.lcCode || null, //	库位编号
            matCodeList: this.whInventorySearch.matCodeList || null, //物料类型查询的物料编号集合
            lcCodeType: this.whInventorySearch.query.lcCodeType || null,
            // lcTypeSub: this.whInventorySearch.query.lcTypeSub || null,
            lcTypeSub: map.join(",") || null,
            fcType: localStorage.getItem("roleCode").indexOf("外仓") !=-1 ? 'WC' : "NEC",
            palletCode: this.whInventorySearch.query.palletCode || null,  //托盘号
          },
        })
        .then((res) => {
          if (res.status == 100) {
            if (res.data.list) {
              res.data.list.forEach((ele)=>{
                ele.lcCode = ele.lcCode.toUpperCase();
              })
              this.whInventorySearch.data = res.data.list || [];
              this.whInventorySearch.total = res.data.total || 0;
            } else {
              this.whInventorySearch.data = [];
              this.whInventorySearch.total = 0;
              //this.$message.error("没有当前查询的数据");
            }
            //}
          } else {
            this.$message.error("错误");
          }
        });
    },
    /* 获取所有的通道(根据用户工厂) */
    getSysWarehouseAll(fcCode) {
      this.$http
        .request({
          url: "/api/sysWarehouse/getSysWarehouseAll",
          method: "GET",
          params: {
            fcCode: fcCode || null
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.WhCodeList = resp.data;
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    /* 远程搜索物料编号 */
    remoteMethod(query) {
      this.loading = true;
      if (query !== "") {
        this.whInventorySearch.query.matCode = query;
        this.getMaterial();
      } else {
        this.whInventorySearch.query.matCode = "";
        this.getMaterial();
      }
      setTimeout(() => {
        this.loading = false;
        if (this.storageObj.materialList != undefined) {
          this.storageObj.materialList = this.storageObj.materialList.filter(
            (item) => {
              return (
                item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1
              );
            }
          );
        }
      }, 200);
    },
    //物料列表
    getMaterial() {
      this.$http
        .request({
          url: "/api/material/getMaterials",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
            mtCode: this.whInventorySearch.query.matCode || null,
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.storageObj.materialList = res.data.list;
          } else {
            this.$message.error("错误");
          }
        });
    },
    /* 获取所有的库位 */
    getSysLocationAll(lcCode) {
      this.$http
        .request({
          url: "/api/location/getLaCodeAllByType",
          method: "GET",
          params: {
            //lcType: "AD",
            fcCode: localStorage.getItem("fcCode") || "",
            lcCode: lcCode || "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            if (resp.data && resp.data.list) {
              this.storageObj.lcCodeList = resp.data.list;
			  this.rowLcCodeList = resp.data.list;
            }else{
              this.storageObj.lcCodeList = [];
			  this.rowLcCodeList =[];
            }
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    /* 远程搜索库位号 */
    remoteMethodLcCode(query) {
      if (query || query == 0) {
        this.lcCodeLoading = true;
        this.getSysLocationAll(query);
        setTimeout(() => {
          this.lcCodeLoading = false;
          if (this.storageObj.lcCodeList != undefined) {
            this.storageObj.lcCodeList = this.storageObj.lcCodeList.filter(
              (item) => {
                return (
                  item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                );
              }
            );
		  	this.rowLcCodeList=this.storageObj.lcCodeList;
          }
        }, 200);
      } else {
        this.storageObj.lcCodeList = [];
		this.rowLcCodeList = [];
      }
    },
    /* 根据工厂编号查询仓库类型 */
    getWarehouseType() {
      this.$http
        .request({
          url: "/api/location/getWarehouseType",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            if (resp.data.total != 0) {
              this.storageObj.warehouse = resp.data.list;
            } else {
              this.storageObj.warehouse = [];
            }
          } else {
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },
    /* 获取首页的数据 */
    getTableData() {
      this.$http
        .request({
          url: "/api/order/getStockList",
          method: "GET",
          params: {
            fcCode: this.mainSearch.query.fcCode || null,
            whCode: this.mainSearch.query.whCode || null,
            matCode: this.mainSearch.query.matCode || null,
            matName: this.mainSearch.query.matName || null,
            batchNo: this.mainSearch.query.batchNo || null,
            boxBarcode: this.mainSearch.query.boxBarcode || null,
            lcCode: this.mainSearch.query.lcCode || null,
            opCode: this.mainSearch.query.orderCode || null,
            beginTime: this.mainSearch.query.date ? this.mainSearch.query.date[0] : null,
            endTime: this.mainSearch.query.date ? this.mainSearch.query.date[1] : null,
            pageNum: this.mainSearch.pageNum,
            pageSize: this.mainSearch.pageSize,
            fcType: localStorage.getItem("roleCode").indexOf("外仓") !=-1 ? 'WC' : "NEC",
			      commonFlag: true, //查询公共库存的库存，不分工厂
            //whType: '1',//仓库库存
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainSearch.data = res.data.list || [];
            this.mainSearch.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        })
        .catch((error) => {
          this.$message.error("错误");
        });
    },
    //表格导出
    downLoadFile() {
        this.downloadLoading = true;
        var paramsObj = {
            // person: this.person || null,
            fcCode: this.LocationAdjustmentSearch.fcCode || null,
            whCode: this.LocationAdjustmentSearch.whCode || null,
            matCode: this.LocationAdjustmentSearch.matCode || null,
            matName: this.LocationAdjustmentSearch.matName || null,
            batchNo: this.LocationAdjustmentSearch.batchNo || null,
            boxBarcode: this.LocationAdjustmentSearch.boxBarcode || null,
            beginTime: this.LocationAdjustmentSearch.date ? this.LocationAdjustmentSearch.date[0] : null,
            endTime: this.LocationAdjustmentSearch.date ? this.LocationAdjustmentSearch.date[1] : null,
            pageNum: 1,
            pageSize: 999999,
        }

        this.$http.request({
            url: '/api/stockMove/getStockMove',
            method: 'GET',
            params: paramsObj
        }).then((resp) => {
            resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                message: '查询失败'
            });
        })
    },
    dateFormat(row, column) {
        var date = row[column.property];
        if (date == undefined) {
            return "";
        }
        return moment(date).format("YYYY-MM-DD");
    },
    downLoad(list) {
      import('@/libs/Export2Excel').then(excel => {
          const tHeader = ['调整前通道', '调整后通道','物料编号', '物料描述', '数量', '批次号', '调整前库位', '调整后库位', '调整时间', 
              '包装编号', '操作人', '操作人工号', '备注'
          ]
          const filterVal = ['oldWhCode',  'newWhCode', 'matCode', 'matName', 'boxQuan', 'batchNo','oldLaCode','newLaCode', 'createTime', 
              'boxBarcode', 'person', 'personNumber', 'remark'
          ]
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '库位调整单'
          })
          // this.logContent = "导出"
          this.logRemarks = "stock_move：导出库位调整记录"
          this.systemLog();
          this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    /* 操作日志 */
    systemLog() {
      let objData = {
          logType: "库存调整",
          logContent: this.logRemarks || "",
          //logRemarks: this.logRemarks || "",
          logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
            url: "api/log/insert",
            method: "POST",
            showLoading: true,
            data: objData,
        })
        .then((resp) => {
            this.logRemarks = "";
            if (resp.status == 100) {}
        })
    },
  },
  activated(){
    /* 获取所有的通道 */
    this.getSysWarehouseAll(localStorage.getItem("fcCode"));
    /* 获取所有的库位 */
    this.getSysLocationAll();
    /* 获取到所有仓库类型 */
    this.getWarehouseType();
    /* 获取首页的数据 */
    this.getTableData();
  },
};
</script>